import React, { type FC, type PropsWithChildren } from 'react';

/**
 * Reports a SSR failure on render. To be placed in (top level) Suspense fallback
 * 🚨Single use per route 🚨
 */
export const ReportSSRFailOnUse: FC<{
	/** ID of the current page, included in reported failure */
	pageId: string;
	/**
	 * @deprecated DO NOT USE unless you know what you are doing; reports failure even if DisableSSRFailDetection is in the tree above this.
	 * You might use this to indicate that a certain nested suspense boundary is critical to your page load, even if it is not the top-level one
	 */
	UNSAFE__forceReporting?: boolean;
}> = () => {
	// this component does nothing. Its .server. version does
	return null;
};

/**
 * Disables SSR render failure detection.
 * To be placed inside Suspense to aid `RLL ssr:false` components
 */
export const DisableSSRFailDetection: FC<PropsWithChildren> = ({ children }) => <>{children}</>;
